// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dLLtJ","colMin":"styles_colMin__WKi6u"};